import React from 'react'
import HeroBanner from '../components/Common Banner Component/HeroBanner'

function PrivacyStatement() {
  return (
    <div style={{background:"white"}}>
         <HeroBanner
            Paragraph={``}
            Heading={`Privacy Statment`}
            HighlightedSpan={""}
            isBtn={false}
            isChevron={false}
            bgImg={'/images/creatives/plane-hero-bg.png'}
        />
        <div className='container py-5' >
            <p className='body-paragraph' style={{fontSize:"20px",color:"black"}}>
                This email may be privileged and/or confidential, and the sender does not waive any 
                related rights and obligations. Any distribution, use or copying of this email or the 
                information it contains by other than an intended recipient is unauthorized. If you 
                received this email in error, please advise the sender (by return email or otherwise) 
                immediately. You have consented to receive the attached electronically at the 
                above-noted email address; please retain a copy of this confirmation for future 
                reference. 
                <br></br>
                <br></br>
                Ce courriel est confidentiel et protégé. L’expéditeur ne renonce pas aux droits et 
                obligations qui s'y rapportent. Toute diffusion, utilisation ou copie de ce courriel ou 
                des renseignements qu’il 
                contient par une personne autre que le (les) destinataire(s) désigné(s) est interdite. 
                Si vous recevez ce courriel par erreur, veuillez en aviser l’expéditeur immédiatement, 
                par retour de courriel 
                ou par un autre moyen. Vous avez accepté de recevoir le(s) document(s) ci-joint(s) 
                par voie électronique à l’adresse courriel indiquée ci-dessus; veuillez conserver une 
                copie de cette confirmation pour les fins de reference future.
            </p>
        </div>
    </div>
  )
}

export default PrivacyStatement